import { AccountEmailDomainId, AccountEmailDomainResponse } from '@/api/account_email_domains';
import {
	useAccountEmailDomains,
	useAccountEmailDomainsArr,
	useReplyToEmails,
	useUnsubscribeContactEmails,
} from '@/store/modules/accountEmailDomains/getters';
import { useStore } from '@/utils/store';

type AccountEmailDomain = AccountEmailDomainResponse;

export const useAccountEmailDomainGetters = () => {
	const { getter } = useStore();
	return {
		accountEmailDomains: getter<Record<AccountEmailDomainId, AccountEmailDomainResponse>>(useAccountEmailDomains),
		useAccountEmailDomainsArr: getter<AccountEmailDomain[]>(useAccountEmailDomainsArr),
		useReplyToEmails: getter<string[]>(useReplyToEmails),
		useUnsubscribeContactEmails: getter<string[]>(useUnsubscribeContactEmails),
	};
};
